import React from 'react';
import './ItemComments.css';

const Commnets = ({ comments }) => {
    return (
        <React.Fragment>
            {
                <div >
                    <div className=" d-flex justify-content-center  text-left">
                        <div className="w-100">
                            <div className="card">
                                <div className="comment-widgets">
                                    {
                                        comments.map(comment => 
                                            <div key={comment._id} className="d-flex flex-row comment-row m-t-0">
                                                <div className="p-2 comments-user-icon">
                                                    <i className="fa fa-user-circle-o"></i>
                                                </div>
                                                <div className="comment-text w-100">
                                                    <h6 className="font-weight-bold">
                                                        {comment.author}
                                                    </h6> 
                                                    <span className="m-b-15 d-block text-justify">
                                                        {comment.comment}
                                                    </span>
                                                    <div className="comment-footer"> 
                                                        <span className="text-muted float-left">
                                                            {comment.insertDate.split(' ')[0]}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </React.Fragment>
    );
}

export default Commnets;